var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEarlyAccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_11093",
    "data-name": "Group 11093",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 130,
    height: 130,
    viewBox: "0 0 130 130",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4262",
    "data-name": "Rectangle 4262",
    width: 130,
    height: 130,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11092",
    "data-name": "Group 11092",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44765",
    "data-name": "Path 44765",
    d: "M130,65A65,65,0,1,1,65,0a65,65,0,0,1,65,65",
    fill: "#ffcd05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44766",
    "data-name": "Path 44766",
    d: "M139.931,241.231l-28.4-2.582v-24.41l22.357-1.466,6.043-5.575ZM115.219,228.6a1.23,1.23,0,0,0-.073,2.322,17.407,17.407,0,0,0,5.3.331,1.356,1.356,0,0,0,0-2.113,26.63,26.63,0,0,0-5.23-.539m10.1,8.111a1.381,1.381,0,0,0-.815-2.242c-1.863.249-8.526-1.325-9.768-.538-.495.314-.464,1.386-.1,1.842a5.388,5.388,0,0,0,1.531.463,73.529,73.529,0,0,0,7.919.784,2.163,2.163,0,0,0,1.234-.31",
    transform: "translate(-75.283 -139.859)",
    fill: "#d9261c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44767",
    "data-name": "Path 44767",
    d: "M229.139,213.535v9.154c-8.035.026-13.017,7.32-10.332,14.909a13.034,13.034,0,0,1,.943,2.223l-13.612,1.41V207.2l5.328,5.117Z",
    transform: "translate(-139.142 -139.859)",
    fill: "#d9261c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44768",
    "data-name": "Path 44768",
    d: "M172.209,85.057c.223-.15.592.024.81.228.767.719,2.121,5.135,2.932,5.517,1.788.359,3.754.436,5.521.816.934.2,1.108.349.476,1.187a49.587,49.587,0,0,1-4.084,3.9c-.335.972.938,4.707.916,6.073-.006.378-.024.576-.359.8l-5.871-2.957-5.505,2.866c-.217.1-.536-.212-.587-.36-.292-.847,1.088-4.966,1.008-6.185l-4.655-4.971c.221-.37.484-.3.82-.356,1.9-.331,3.855-.461,5.754-.817Z",
    transform: "translate(-109.897 -57.375)",
    fill: "#d9261c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44769",
    "data-name": "Path 44769",
    d: "M97.042,208.714c-.106-.407.169-.469.349-.7.487-.636,3.452-3.572,4.041-3.7l26.353-2.162c.106.4-.162.47-.348.706-1.091,1.383-2.844,2.6-3.979,4l-.487.217Z",
    transform: "translate(-65.487 -136.447)",
    fill: "#d9261c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44770",
    "data-name": "Path 44770",
    d: "M238,208.5c-6.806-.659-13.656-.953-20.489-1.454l-4.155-4.174,20.483,1.93c1.4.25,3.125,2.7,4.162,3.7",
    transform: "translate(-144.017 -136.939)",
    fill: "#d9261c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44771",
    "data-name": "Path 44771",
    d: "M121.354,117.315c.443.5-2.346,2.122-2.532,2.746-.344,1.157.457,2.837.419,4.058l-3.637-1.625c-.938.048-2.371,1.522-3.094,1.591-.295.028-.358-.1-.516-.309l.642-3.476-2.547-2.984,3.654-.69,1.86-3.3,1.994,3.4Z",
    transform: "translate(-74.311 -76.496)",
    fill: "#d9261c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44772",
    "data-name": "Path 44772",
    d: "M247.39,113.238l1.645,3.4,3.756.587-2.538,2.984.425,3.82-3.615-1.644-3.424,1.644.431-3.818-2.543-2.984,3.758-.585c.283-.166,1.173-2.572,1.569-3.114.156-.214.008-.416.536-.292",
    transform: "translate(-163.031 -76.41)",
    fill: "#d9261c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44773",
    "data-name": "Path 44773",
    d: "M218.048,160.216a1.511,1.511,0,0,1-.245-1.167A97.141,97.141,0,0,1,221.263,147c.811-1.639,2.488-1.077,2.343.685a101.352,101.352,0,0,1-3.387,11.885c-.4.908-1.431,1.382-2.172.648",
    transform: "translate(-147.005 -98.566)",
    fill: "#d9261c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44774",
    "data-name": "Path 44774",
    d: "M153.359,147.573l3.771,12.552c-.063,1.558-1.667,2.027-2.425.534a97.224,97.224,0,0,1-3.348-11.691c-.173-1.528.626-2.078,2-1.4",
    transform: "translate(-102.15 -99.416)",
    fill: "#d9261c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44775",
    "data-name": "Path 44775",
    d: "M246.26,157.32a2.442,2.442,0,0,1,1.49.077,1.427,1.427,0,0,1,.423.759c.192,1.335-3.714,8.013-4.127,9.859-.872,1.386-2.618.769-2.306-.884a80.4,80.4,0,0,1,4-9.159c.147-.25.2-.541.52-.652",
    transform: "translate(-163.151 -106.137)",
    fill: "#d9261c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44776",
    "data-name": "Path 44776",
    d: "M125.855,157.453c.644-.1.955.269,1.288.733a79.238,79.238,0,0,1,3.955,8.969c.455,1.738-1.388,2.445-2.328.9a67.756,67.756,0,0,1-3.736-8.47c-.3-.9-.374-1.952.82-2.136",
    transform: "translate(-84.273 -106.27)",
    fill: "#d9261c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44777",
    "data-name": "Path 44777",
    d: "M189.527,155.78c.261-.929,2.347-.632,2.347,0v9.154c0,.673-1.879,1.208-2.347.235Z",
    transform: "translate(-127.931 -104.753)",
    fill: "#d9261c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44778",
    "data-name": "Path 44778",
    d: "M257.41,261.4c-10.893,1.27-9.664,18.768,2.725,17.277,10.39-1.25,9.2-18.667-2.725-17.277m5.741,6.483-5.732,5.734a.5.5,0,0,1-.57-.03l-2.828-2.851c-.332-.491.054-.96.438-1.266a.737.737,0,0,1,1.043.036l1.666,1.633,4.5-4.491a1.073,1.073,0,0,1,.441-.242.743.743,0,0,1,.621.189c.4.317.774.788.425,1.288",
    transform: "translate(-168.736 -176.391)",
    fill: "#d9261c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarlyAccess);
export default __webpack_public_path__ + "static/media/early-access.b2669bd7ce4116ff4b460127c13b0d55.svg";
export { ForwardRef as ReactComponent };